"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseValue = exports.chainFocus = void 0;
const chainFocus = (editor, chainFunc) => {
    const chain = editor.chain().focus();
    chainFunc(chain).run();
};
exports.chainFocus = chainFocus;
const parseValue = (value) => {
    if (value && typeof value === 'string') {
        try {
            return JSON.parse(value);
        }
        catch (error) {
            console.error(error.message);
        }
    }
    return value;
};
exports.parseValue = parseValue;
